// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { useLocation, useNavigate } from "react-router-dom";
// import { BlinkLoader } from "../components/loader";
// import { io } from "socket.io-client";
// import { setCookie } from "../config/webStorage";

// const LoginApprovalWait = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();

//   const { requestObjId, userName } = state || {};
//   const [status, setStatus] = useState("pending");

//   const socketRef = useRef(null);
//   const pollingRef = useRef(null);

//   /* 🚫 Redirect if direct access */
//   useEffect(() => {
//     if (!requestObjId) {
//       navigate("/login", { replace: true });
//     }
//   }, [requestObjId, navigate]);

//   /* 🔥 SOCKET CONNECTION */
//   useEffect(() => {
//     if (!requestObjId) return;

//     socketRef.current = io(apiurl, {
//       transports: ["websocket"],
//       reconnection: true,
//     });

//     socketRef.current.on("LOGIN_APPROVED", async ({ requestObjId: id }) => {
//       if (id !== requestObjId) return;
//       handleApproval();
//     });

//     socketRef.current.on("LOGIN_REJECTED", ({ requestObjId: id }) => {
//       if (id === requestObjId) {
//         stopPolling();
//         setStatus("rejected");
//       }
//     });

//     return () => {
//       socketRef.current?.disconnect();
//     };
//   }, [requestObjId]);

//   /* 🔄 POLLING (Backup if socket fails) */
//   useEffect(() => {
//     if (!requestObjId) return;

//     pollingRef.current = setInterval(checkStatus, 3000);

//     return stopPolling;
//   }, [requestObjId]);

//   /* 🔁 CHECK STATUS API */
//   const checkStatus = async () => {
//     try {
//       const { data } = await axios.post(
//         `${apiurl}/api/user/login-request-status`,
//         { requestObjId }
//       );


//       console.log("data",data);

//       if (data.status === "approved") {
//         handleApproval();
//       }

//       if (data.status === "rejected") {
//         stopPolling();
//         setStatus("rejected");
//       }
//     } catch (err) {
//       console.error("Polling error:", err);
//     }
//   };

//   /* ✅ HANDLE APPROVAL */
//   const handleApproval = async () => {
//     try {
//       stopPolling();

//       const { data } = await axios.post(
//         `${apiurl}/api/user/login-request-status`,
//         { requestObjId }
//       );

//       if (data.token) {
//         setCookie("scspt", data.token);
//         // navigate("/dashboard", { replace: true });
//       window.location.href = "/dashboard";
//       }
//     } catch (err) {
//       console.error("Approval fetch failed:", err);
//     }
//   };

//   /* 🧹 STOP POLLING */
//   const stopPolling = () => {
//     if (pollingRef.current) {
//       clearInterval(pollingRef.current);
//       pollingRef.current = null;
//     }
//   };

//   /* 🎨 UI */
//   return (
//     <div className="min-h-screen flex items-center justify-center bg-[#f7f6f3]">
//       <div className="bg-white p-8 rounded-xl shadow-md max-w-md text-center">
//         <h2 className="text-xl font-semibold mb-2">
//           Login Approval Required
//         </h2>

//         <p className="text-gray-500 mb-6">
//           Hi <b>{userName}</b>, please wait while your login request is reviewed.
//         </p>

//         {status === "pending" && (
//           <div className="flex flex-col items-center gap-3">
//             <BlinkLoader />
//             <span className="text-sm text-gray-600">
//               Waiting for admin approval…
//             </span>
//           </div>
//         )}

//         {status === "rejected" && (
//           <div className="text-red-500 font-medium">
//             ❌ Login request rejected. Please contact admin.
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LoginApprovalWait;
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { useLocation, useNavigate } from "react-router-dom";
import { BlinkLoader } from "../components/loader";
import { io } from "socket.io-client";
import { setCookie } from "../config/webStorage";
import { CheckCircle, XCircle, ShieldCheck } from "lucide-react";

const LoginApprovalWait = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { requestObjId, userName, userId } = state || {};
  const [status, setStatus] = useState("pending");

  const socketRef = useRef(null);
  const pollingRef = useRef(null);

  /* 🚫 Prevent direct access */
  useEffect(() => {
    if (!requestObjId) {
      navigate("/?please-login", { replace: true });
    }
  }, [requestObjId, navigate]);

  /* 🔥 SOCKET (PRIMARY) */
  useEffect(() => {
    if (!requestObjId) return;

    socketRef.current = io(apiurl, {
      transports: ["websocket"],
      reconnection: true,
    });

    // 🔐 Join personal room
    if (userId) {
      socketRef.current.emit("JOIN_USER", userId);
    }

    socketRef.current.on("LOGIN_APPROVED", ({ token }) => {
      stopPolling();
      setStatus("approved");
      setCookie("scspt", token);
      setTimeout(() => (window.location.href = "/dashboard"), 800);
    });

    socketRef.current.on("LOGIN_REJECTED", () => {
      stopPolling();
      setStatus("rejected");
    });

    return () => {
      socketRef.current?.disconnect();
    };
  }, [requestObjId, userId]);

  /* 🔄 POLLING (Fallback – low frequency) */
  useEffect(() => {
    if (!requestObjId) return;
    pollingRef.current = setInterval(checkStatus, 8000);
    return stopPolling;
  }, [requestObjId]);

  /* 🔁 Lightweight status check */
  const checkStatus = async () => {
    try {
      const { data } = await axios.post(
        `${apiurl}/api/user/login-request-status`,
        { requestObjId }
      );

      if (data.status === "approved") {
        stopPolling();
        setCookie("scspt", data.token);
        window.location.href = "/dashboard";
      }

      if (data.status === "rejected") {
        stopPolling();
        setStatus("rejected");
      }
    } catch (err) {
      console.error("Polling error:", err);
    }
  };

  /* 🧹 Stop polling */
  const stopPolling = () => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  };

  /* 🎨 UI */
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">
        
        <div className="flex justify-center mb-4">
          <div className="h-14 w-14 rounded-full bg-indigo-100 flex items-center justify-center">
            <ShieldCheck className="text-indigo-600" size={28} />
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-gray-800">
          Login Approval Required
        </h2>

        <p className="text-gray-500 mt-2">
          Hi <b>{userName}</b>, your login request is awaiting admin approval.
        </p>

        {/* Pending */}
        {status === "pending" && (
          <div className="mt-6 flex flex-col items-center gap-3">
            <BlinkLoader />
            <span className="text-sm text-gray-600">
              Please keep this window open…
            </span>
          </div>
        )}

        {/* Approved */}
        {status === "approved" && (
          <div className="mt-6 flex flex-col items-center gap-2 text-green-600">
            <CheckCircle size={32} />
            <span className="font-medium">Approved! Redirecting…</span>
          </div>
        )}

        {/* Rejected */}
        {status === "rejected" && (
          <div className="mt-6 flex flex-col items-center gap-2 text-red-500">
            <XCircle size={32} />
            <span className="font-medium">
              Login request rejected. Please contact admin.
            </span>
            <button
              onClick={() => navigate("/")}
              className="mt-3 text-sm text-indigo-600 hover:underline"
            >
              Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginApprovalWait;
